import { render, staticRenderFns } from "./LpuPrices.vue?vue&type=template&id=f9a2f062&"
import script from "./LpuPrices.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPrices.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a2f062')) {
      api.createRecord('f9a2f062', component.options)
    } else {
      api.reload('f9a2f062', component.options)
    }
    module.hot.accept("./LpuPrices.vue?vue&type=template&id=f9a2f062&", function () {
      api.rerender('f9a2f062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/LpuPrices.vue"
export default component.exports